import { makeStyles } from '@material-ui/core/styles';

export default function ProdutoCardCss() {
    return makeStyles(theme => ({
        backdrop: {
            // Backdrop precisa ficar acima de todas modals
            zIndex: theme.zIndex.modal + 1,
            color: '#fff',
        },
    }));
};
